/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreateJobAdStaticBuildingBlock } from '@coin/shared/core/util-models-v2';
import { JobAdStaticBuildingBlock } from '@coin/shared/core/util-models-v2';
import { JobAdStaticBuildingBlockDeletion } from '@coin/shared/core/util-models-v2';
import { PageOfJobAdStaticBuildingBlockListItem } from '@coin/shared/core/util-models-v2';
import { UpdateJobAdStaticBuildingBlock } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateJobAdStaticBuildingBlocksParams {
  createJobAdStaticBuildingBlock?: CreateJobAdStaticBuildingBlock;
}

export interface DeleteJobAdStaticBuildingBlocksParams {
  id: string;
}

export interface GetJobAdStaticBuildingBlocksParams {
  id: string;
}

export interface PageJobAdStaticBuildingBlocksParams {
  page?: number;
  size?: number;
  search?: string;
  languages?: Array<string>;
}

export interface UpdateJobAdStaticBuildingBlocksParams {
  id: string;
  updateJobAdStaticBuildingBlock?: UpdateJobAdStaticBuildingBlock;
}

export interface ValidateDeletionJobAdStaticBuildingBlocksParams {
  id: string;
}

@Injectable({
  providedIn: 'root'
})
export class HeadcountJobAdStaticBuildingBlocksService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createJobAdStaticBuildingBlocks(
    requestParameters?: CreateJobAdStaticBuildingBlocksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAdStaticBuildingBlock>;
  public createJobAdStaticBuildingBlocks(
    requestParameters?: CreateJobAdStaticBuildingBlocksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAdStaticBuildingBlock>>;
  public createJobAdStaticBuildingBlocks(
    requestParameters?: CreateJobAdStaticBuildingBlocksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAdStaticBuildingBlock>>;
  public createJobAdStaticBuildingBlocks(
    requestParameters?: CreateJobAdStaticBuildingBlocksParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/headcount/job-ad-static-building-blocks`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createJobAdStaticBuildingBlock,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteJobAdStaticBuildingBlocks(
    requestParameters?: DeleteJobAdStaticBuildingBlocksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteJobAdStaticBuildingBlocks(
    requestParameters?: DeleteJobAdStaticBuildingBlocksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteJobAdStaticBuildingBlocks(
    requestParameters?: DeleteJobAdStaticBuildingBlocksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteJobAdStaticBuildingBlocks(
    requestParameters?: DeleteJobAdStaticBuildingBlocksParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteJobAdStaticBuildingBlocks', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/master/headcount/job-ad-static-building-blocks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getJobAdStaticBuildingBlocks(
    requestParameters?: GetJobAdStaticBuildingBlocksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAdStaticBuildingBlock>;
  public getJobAdStaticBuildingBlocks(
    requestParameters?: GetJobAdStaticBuildingBlocksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAdStaticBuildingBlock>>;
  public getJobAdStaticBuildingBlocks(
    requestParameters?: GetJobAdStaticBuildingBlocksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAdStaticBuildingBlock>>;
  public getJobAdStaticBuildingBlocks(
    requestParameters?: GetJobAdStaticBuildingBlocksParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getJobAdStaticBuildingBlocks', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/headcount/job-ad-static-building-blocks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageJobAdStaticBuildingBlocks(
    requestParameters?: PageJobAdStaticBuildingBlocksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfJobAdStaticBuildingBlockListItem>;
  public pageJobAdStaticBuildingBlocks(
    requestParameters?: PageJobAdStaticBuildingBlocksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfJobAdStaticBuildingBlockListItem>>;
  public pageJobAdStaticBuildingBlocks(
    requestParameters?: PageJobAdStaticBuildingBlocksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfJobAdStaticBuildingBlockListItem>>;
  public pageJobAdStaticBuildingBlocks(
    requestParameters?: PageJobAdStaticBuildingBlocksParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/headcount/job-ad-static-building-blocks`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        search: requestParameters?.search,
        languages: requestParameters?.languages
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateJobAdStaticBuildingBlocks(
    requestParameters?: UpdateJobAdStaticBuildingBlocksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAdStaticBuildingBlock>;
  public updateJobAdStaticBuildingBlocks(
    requestParameters?: UpdateJobAdStaticBuildingBlocksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAdStaticBuildingBlock>>;
  public updateJobAdStaticBuildingBlocks(
    requestParameters?: UpdateJobAdStaticBuildingBlocksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAdStaticBuildingBlock>>;
  public updateJobAdStaticBuildingBlocks(
    requestParameters?: UpdateJobAdStaticBuildingBlocksParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateJobAdStaticBuildingBlocks', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/master/headcount/job-ad-static-building-blocks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateJobAdStaticBuildingBlock,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateDeletionJobAdStaticBuildingBlocks(
    requestParameters?: ValidateDeletionJobAdStaticBuildingBlocksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAdStaticBuildingBlockDeletion>;
  public validateDeletionJobAdStaticBuildingBlocks(
    requestParameters?: ValidateDeletionJobAdStaticBuildingBlocksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAdStaticBuildingBlockDeletion>>;
  public validateDeletionJobAdStaticBuildingBlocks(
    requestParameters?: ValidateDeletionJobAdStaticBuildingBlocksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAdStaticBuildingBlockDeletion>>;
  public validateDeletionJobAdStaticBuildingBlocks(
    requestParameters?: ValidateDeletionJobAdStaticBuildingBlocksParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('validateDeletionJobAdStaticBuildingBlocks', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/headcount/job-ad-static-building-blocks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/deletion-validation`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }
}
